<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('commands')">Command</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.command_name }}
    </h1>
    <trashed-message v-if="command.deleted_at" class="mb-6" @restore="restore">
      This command has been deleted.
    </trashed-message>
    <preview :preview_message=form.command_reply />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.command_name" class="pr-6 pb-8 w-full" label="Command Name" :error="this.$page.props.errors.command_name"/>
          <textarea-input v-model="form.command_reply" class="pr-6 pb-8 w-full" label="Command Reply" rows="4" max-rows="6" :error="this.$page.props.errors.command_reply"/>
          <!--
          <text-input v-model="form.stream_title_hashtag" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Title Hashtags" />
          <text-input v-model="form.stream_tags" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Hash Tags" />
          <text-input v-model="form.stream_game" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Game" />
          -->
          <select-input v-model="form.mention_user" class="pr-6 pb-8 w-full lg:w-1/2" label="Mention User">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
          <select-input v-model="form.is_enabled" class="pr-6 pb-8 w-full lg:w-1/2" label="Is Enabled">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!command.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Command</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Command</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '../../Shared/TextareaInput.vue'
import Preview from '@/Shared/Preview.vue'

export default {
  metaInfo() {
    return {
      title: `${this.form.command_name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextareaInput,
    Preview,
  },
  layout: Layout,
  props: {
    command: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        command_name: this.command.command_name,
        command_reply: this.command.command_reply,
        mention_user: this.command.mention_user == true ? '1' : '0',
        stream_title_hashtag: this.command.stream_title_hashtag,
        stream_tags: this.command.stream_tags,
        stream_game: this.command.stream_game,
        is_enabled: this.command.is_enabled == true ? '1' : '0',
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('commands.update', this.command.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this command?')) {
        this.$inertia.delete(this.route('commands.destroy', this.command.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this command?')) {
        this.$inertia.put(this.route('commands.restore', this.command.id))
      }
    },
  },
}
</script>
